import FormSelectBox from '../../../../../components/Inputs/FormSelectBox';
import { useGetPreClaimsReasonTypeList } from '../../hooks';

export const PreClaimsReasonTypeSelect = ({
  placeholder = 'Select Reason Type',
  label = 'Reason Type',
  rules = [],
  name,
  editMode,
  margin,
  onChange,
  value = '',
  className = '',
  tabIndex,
  disableValidation = false,
}) => {
  const { data: options, isLoading } = useGetPreClaimsReasonTypeList();

  return (
    <FormSelectBox
      loading={isLoading}
      options={options}
      placeholder={placeholder}
      label={label}
      margin={margin}
      rules={rules}
      name={name}
      editMode={editMode}
      onChange={onChange}
      value={value}
      className={className}
      tabIndex={tabIndex}
      disableValidation={disableValidation}
    />
  );
};
